import React from 'react'
import RedBackground from "../ThemeComponents/RedBackground";
import personAutoImage from "../assets/images/person-auto.png";
import personenbusImage from "../assets/images/personen-bus.png";
import bestelbusImage from "../assets/images/bestelbus.png";
import electricImage from "../assets/images/electric.png";

const FakeLocationPage = ({locationInfo}) => {
    const webContent = locationInfo?.web_content || {}
    const hero = webContent.hero || {}
    const features = webContent.features || {}
    const bottom = webContent.bottom || {}
    const hasHeroMap = Boolean(hero.map_image)
    const websiteUrlRaw = String(locationInfo?.website || webContent?.website || "").trim()
    const websiteUrl = websiteUrlRaw
        ? (/^https?:\/\//i.test(websiteUrlRaw) ? websiteUrlRaw : `https://${websiteUrlRaw}`)
        : ""

    const renderHtml = (value) => value ? <div dangerouslySetInnerHTML={{__html: value}} /> : null

    const cardItems = [
        {title: 'Personenauto', image: personAutoImage},
        {title: 'Personenbus', image: personenbusImage},
        {title: 'Bestelbus/verhuiswagen', image: bestelbusImage},
        {title: 'Elektrisch rijden', image: electricImage},
    ]

    return (
        <div className="kav-seo-wrapper">
            <section className="fake-hero">
                <div className="container">
                    <div className="row align-items-center fake-hero__layout">
                        <div className={`${hasHeroMap ? "col-lg-7" : "col-12"} fake-page-hero-text`}>
                            <h2 className="fake-hero__title">{hero.title}</h2>
                            <div className="fake-hero__text">{renderHtml(hero.text)}</div>
                        </div>
                        {hasHeroMap ? (
                            <div className="col-lg-5 fake-hero__mapCol">
                                <div className="fake-hero__imageWrap">
                                    <img src={hero.map_image} alt="" className="fake-hero__image fake-hero__map" />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </section>

            <section className="fake-cards">
                <div className="container">
                    <div className="row">
                        {cardItems.map((card) => (
                            <div className="col-lg-3 col-md-6" key={card.title}>
                                <div className="fake-card">
                                    <h4 className="fake-card__title">{card.title}</h4>
                                    <div className="fake-card__imageWrap">
                                        <img src={card.image} alt="" />
                                    </div>
                                    {websiteUrl ? (
                                        <a
                                            className="fake-card__cta"
                                            href={websiteUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Direct huren
                                            <i className="bi bi-arrow-right" aria-hidden="true"></i>
                                        </a>
                                    ) : (
                                        <button type="button" className="fake-card__cta" disabled>
                                            Direct huren
                                            <i className="bi bi-arrow-right" aria-hidden="true"></i>
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <RedBackground>
                <section className="fake-features">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <h3>{features.left?.title}</h3>
                                <div className="fake-html">{renderHtml(features.left?.text)}</div>
                                <div className="fake-html">{renderHtml(features.left?.bullets)}</div>
                            </div>
                            <div className="col-md-6">
                                <h3>{features.right?.title}</h3>
                                <div className="fake-html">{renderHtml(features.right?.text)}</div>
                                <div className="fake-html">{renderHtml(features.right?.bullets)}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </RedBackground>

            <section className="fake-bottom">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <h3>{bottom.left?.title}</h3>
                            <div className="fake-html">{renderHtml(bottom.left?.text)}</div>
                            <h4 className="fake-bottom__cta">{bottom.left?.cta_title}</h4>
                            <div className="fake-html">{renderHtml(bottom.left?.cta_text)}</div>
                        </div>
                        <div className="col-md-6">
                            {bottom.right?.image ? (
                                <div className="fake-bottom__imageWrap">
                                    <img src={bottom.right?.image} alt="" />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default FakeLocationPage
